import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import xTrackPage from '@/views/xTrackPage.vue'
import proVisionPage from '@/views/proVisionPage.vue'
import xTrackAssetsPage from '@/views/xTrackAssetsPage.vue'
import xCoolPage from '@/views/xCoolPage.vue'
import xCargoPage from '@/views/xCargoPage.vue'
import xCargoVisionPage from '@/views/xCargoVisionPage.vue'
import eldPage from '@/views/eldPage.vue'
import xAppsPage from '@/views/xAppsPage.vue'
import xAppsPrometheusMobilePage from '@/views/xAppsPrometheusMobilePage.vue'
import xAppsPrometheusDriversMobilePage from '@/views/xAppsPrometheusDriversMobilePage.vue'
import xAppsXCoolPage from '@/views/xAppsXCoolPage.vue'
import xAppsXCargoPage from '@/views/xAppsXCargoPage.vue'
import xAppsXCargoDockPage from '@/views/xAppsXCargoDockPage.vue'
import dealerPage from '@/views/dealerPage.vue'
import ProHUBPage from '@/views/ProHUBPage.vue'
import BlogPage from "@/views/BlogPage.vue";
import ContactsPage from "@/views/ContactsPage.vue";
// import ContactForm from "@/components/base/ContactForm";

const routes = [
  {
    path: '/product/xtrack',
    name: 'Products.track',
    component: xTrackPage
  },
  {
    path: '/product/xtrack-assets',
    name: 'Products.assets',
    component: xTrackAssetsPage
  },
  {
    path: '/product/provision',
    name: 'Products.vision',
    component: proVisionPage
  },
  {
    path: '/product/xcool',
    name: 'Products.reefer',
    component: xCoolPage
  },
  {
    path: '/product/xcargo',
    name: 'Products.cargo',
    component: xCargoPage
  },
  {
    path: '/product/xcargo-vision',
    name: 'Products.cargo-vision',
    component: xCargoVisionPage
  },
  {
    path: '/product/xeld',
    name: 'Products.eld',
    component: eldPage
  },
  {
    path: '/product/xapps',
    name: 'Products.apps',
    component: xAppsPage
  },
  {
    path: '/product/xapps/prometheus-mobile',
    name: 'Products.xapps.prometheus-mobile',
    component: xAppsPrometheusMobilePage
  },
  {
    path: '/product/xapps/prometheus-drivers',
    name: 'Products.xapps.prometheus-drivers',
    component: xAppsPrometheusDriversMobilePage
  },
  {
    path: '/product/xapps/xcool-app',
    name: 'Products.xapps.xcool-app',
    component: xAppsXCoolPage
  },
  {
    path: '/product/xapps/xcargo-app',
    name: 'Products.xapps.xcargo-app',
    component: xAppsXCargoPage
  },
  {
    path: '/product/xapps/xcargo-dock-app',
    name: 'Products.xapps.xcargo-dock-app',
    component: xAppsXCargoDockPage
  },
  {
    path: '/partners',
    name: 'Partners',
    component: dealerPage
  },
  {
    path: '/pro-hub',
    name: 'ProHub',
    component: ProHUBPage
  },
  {
    path: '/blog',
    name: 'Blog',
    component: BlogPage
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: ContactsPage
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'Main',
    component: HomePage
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to) => {
  if(to.name == 'Main' && to.path != '/'){
    return '/'
  }
  return true
})
export default router
